import moment from 'moment';
import { useAvailabilityCalendarContext } from './availability-calendar-context';

const calculatePeriodText = (startDate: string, endDate: string) => {
  const startMoment = moment(startDate);
  const endMoment = moment(endDate);

  if (startMoment.isSame(endMoment, 'month')) {
    return startMoment.format('MMM YYYY');
  }

  if (startMoment.isSame(endMoment, 'year')) {
    return `${startMoment.format('MMM')} - ${endMoment.format('MMM YYYY')}`;
  }

  return `${startMoment.format('MMM YYYY')} - ${endMoment.format('MMM YYYY')}`;
};

const AvailabilityCalendarPeriod = () => {
  const { getRange } = useAvailabilityCalendarContext();
  const range = getRange();
  const periodText = calculatePeriodText(range[0], range.at(-1));

  return (
    <div className='heading-5'>{periodText}</div>
  );
};

export default AvailabilityCalendarPeriod;
